let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j53ag")).then(() => parcelRequire('6xXDZ'));